import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { useDispatch } from "react-redux";
import { edit, getCategory } from "../../../actions/mainCategory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../../components/alert/alert.component";
import HeadingPrimary from "../../../components/custom-heading/heading-primary";
import HeadingSecondary from "../../../components/custom-heading/heading-secondary";
import CustomInput from "../../../components/custom-input/custom-input";
import CustomTextArea from "../../../components/custom-input/custom-textarea";
import CustomRadioInput from "../../../components/custom-input/custom-radio-input";
import CustomButton, {
  CustomButtonClasses,
  CustomButtonTypes,
} from "../../../components/custom-button/custom-button";
import MultiValueSelect from "./components/multi-value-select/multi-value-select";
import ImageUploaderField from "../../../components/img-uploader-field/img-uploader-field";

const Edit = () => {
  const query = new URLSearchParams(window.location.search);
  const id = query?.get("id");
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    displayName: "",
    slug: "",
    image: "",
    description: "",
    metaTag: [],
    metaDescription: "",
    metaKeyword: [],
    seoKeyword: [],
    show: true,
    isBase64: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await dispatch(getCategory(id));
        const metaTagData = [];
        res?.metaTag?.forEach((element) => {
          metaTagData.push({ value: element, label: element });
        });

        const metaKeywordData = [];
        res?.metaKeyword?.forEach((_element) => {
          metaKeywordData.push({ value: _element, label: _element });
        });

        const seoKeywordData = [];
        res?.seoKeyword?.forEach((element) => {
          seoKeywordData.push({ value: element, label: element });
        });

        setFormData((prev) => ({
          ...prev,
          image: res?.image,
          name: res?.name,
          displayName: res?.displayName,
          description: res?.description,
          metaDescription: res?.metaDescription,
          metaKeyword: metaKeywordData,
          metaTag: metaTagData,
          seoKeyword: seoKeywordData,
          show: res?.show,
          slug: res?.slug,
        }));
      } catch (error) {
        console.log("error value is : ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleImageChange = async (e) => {
    const base64Image = await toBase64(e[0]);
    setFormData((prev) => ({ ...prev, image: base64Image, isBase64: true }));
  };

  const submitHandler = async () => {
    setLoading(true);
    const {
      name,
      displayName,
      slug,
      image,
      description,
      metaDescription,
      show,
      isBase64,
    } = formData;

    const metaTagData = formData.metaTag.map((element) => element.value);
    const metaKeywordData = formData.metaKeyword.map(
      (_element) => _element.value
    );
    const seoKeywordData = formData.seoKeyword.map((element) => element.value);

    const dataTOsend = {
      name,
      displayName,
      slug,
      mainCategoryId: id,
      image,
      metaTag: metaTagData,
      metaDescription,
      metaKeyword: metaKeywordData,
      seoKeyword: seoKeywordData,
      description,
      show,
      isBase64,
    };
    const res = await dispatch(edit(dataTOsend));
    setLoading(false);
    if (res) {
      toast(`${res.data}`, { containerId: "B" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const showTagOfArray = (e, key) => {
    const data = e.map((item) => ({
      value: item.value,
      label: item.value,
    }));
    setFormData((prev) => ({ ...prev, [key]: data }));
  };

  return (
    <div className="container-scroller">
      {loading && <TopBarProgress />}

      <ToastContainer
      stacked 
        enableMultiContainer
        containerId={"B"}
        // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
      />

      <div className="page-header">
        <HeadingPrimary>Edit Main Category</HeadingPrimary>

        <div style={{ fontSize: ".9rem" }}>
          <Link to="/admin/main-categories">Main Categories</Link> /&nbsp;Create
          Main Category
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div
            className="card p-0"
            style={{
              border: "1px solid #dcdcdc",
            }}
          >
            <div className="card-body p-0">
              <HeadingSecondary>Edit Item Category</HeadingSecondary>
              <Alert />

              <form className="forms-sample m-3">
                <CustomInput
                  label="Name"
                  name="name"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.name}
                />

                <CustomInput
                  label="Display Name"
                  name="displayName"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.displayName}
                />

                <CustomInput
                  label="Slug"
                  name="slug"
                  type="text"
                  placeholder="slug"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.slug}
                />

                <ImageUploaderField
                  labelStyles={{ fontWeight: "bold" }}
                  label="Image upload"
                  buttonText="Choose image"
                  name="image"
                  onChange={handleImageChange}
                />

                <div className="input-group col-xs-12">
                  <img
                    src={formData?.image && formData?.image}
                    alt="category-Img"
                    width="100"
                    height="50"
                    style={{ marginBottom: "2rem" }}
                  />
                </div>

                {!loading && (
                  <MultiValueSelect
                    label="Meta Tags"
                    defaultValue={formData?.metaTag}
                    name="metaTags"
                    onChange={(value) => showTagOfArray(value, "metaTag")}
                  />
                )}

                {!loading && (
                  <MultiValueSelect
                    label="Meta Keywords"
                    defaultValue={formData?.metaKeyword}
                    name="metaKeyword"
                    onChange={(value) => showTagOfArray(value, "metaKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Meta Description"
                  name="metaDescription"
                  rows={6}
                  value={formData.metaDescription}
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                />

                {!loading && (
                  <MultiValueSelect
                    label="Seo Keywords"
                    defaultValue={formData?.seoKeyword}
                    name="seoKeyword"
                    onChange={(value) => showTagOfArray(value, "seoKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Description"
                  name="description"
                  rows={6}
                  value={formData.description}
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                />

                <div className="form-group ">
                  <label className="col-sm-3 col-form-label font-weight-bold">
                    Show in Header
                  </label>
                  <div className="col-sm-12">
                    <CustomRadioInput
                      label="Yes"
                      required={true}
                      type="radio"
                      id="radio1"
                      name="membershipRadios"
                      checked={formData?.show === true}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData?.show}
                      onChange={() => setFormData({ ...formData, show: true })}
                    />
                  </div>

                  <div className="col-sm-5">
                    <CustomRadioInput
                      label="No"
                      required={true}
                      type="radio"
                      name="membershipRadios"
                      id="radio2"
                      checked={formData?.show === false}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: false })}
                    />
                  </div>
                </div>

                <CustomButton
                  type={CustomButtonTypes.BUTTON}
                  className={CustomButtonClasses.PRIMARY}
                  onClick={() => submitHandler()}
                >
                  Update
                </CustomButton>

                <Link to={"/admin/main-categories"}>
                  <button className="btn btn-light">Cancel</button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
